import Tabs from '@components/Tabs';
import { Text } from '@goodfynd/react-web.lib.ui';
import { styled } from '@goodfynd/react-web.theme';
import { Stack } from '@mui/material';

import Container from '../../layout/Container';

export const CARD_HEIGHT = 148;

export const StyledCardBody = styled('div', {
  alignItems: 'stretch',
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  width: '100%',
});

export const StyledCardContent = styled('div', {
  display: 'flex',
  flex: 1,
  flexDirection: 'column',
  height: CARD_HEIGHT - 32,
  justifyContent: 'space-between',
  paddingRight: 16,
});

export const StyledCardsContainer = styled('section', {
  display: 'flex',
  flex: '1 1 auto',
  flexWrap: 'wrap',
  gap: 24,
  marginTop: 16,
  '@sm': {
    gap: 0,
    marginTop: 8,
  },
});

export const StyledCategory = styled('section', {
  minHeight: 313,
});

export const StyledCategoryContainer = styled('section', {
  padding: '0 24px',
  '@sm': {
    padding: '0 16px',
  },
  scrollMarginTop: 70,
  variants: {
    loading: {
      true: {
        marginTop: 48,
        '@sm': {
          marginTop: 32,
        },
      },
    },
  },
});

export const StyledCategoryTabs = styled(Tabs, {
  '&.MuiTabs-root': {
    paddingLeft: 16,
    paddingRight: 16,
    overflow: 'auto',
    maxWidth: '100vw',
  },
});

export const StyledContainer = styled(Container, {
  '&.MuiContainer-root': {
    '@sm': {
      paddingLeft: 0,
      paddingRight: 0,
      paddgingTop: 0,
    },
    '@md': {
      paddingTop: 32,
    },
  },
});

export const StyledImageContainer = styled('div', {
  backgroundPosition: 'center',
  backgroundRepeat: 'no-repeat',
  backgroundSize: 'cover',
  borderRadius: 8,
  aspectRatio: '1 / 1',
  width: 112,
});

export const StyledPrice = styled(Text, {
  color: 'var(--TextIconPrimary)',
});

export const StyledProductCard = styled('section', {
  borderColor: '$Neutral03',
  borderRadius: 8,
  borderStyle: 'solid',
  borderWidth: 1,
  height: 148,
  minWidth: '100%',
  padding: 16,
  '@sm': {
    borderRadius: 0,
    borderLeft: 'none',
    borderRight: 'none',
    borderTop: 'none',
    '+ section': {
      marginTop: 0,
    },
  },
  '@md': {
    maxWidth: 335,
    minWidth: 335,
  },
  '@lg': {
    maxWidth: 380,
    minWidth: 380,
  },
});

export const StyledProductContainer = styled('section', {
  '> section:not(first-child)': {
    marginTop: 40,
    '@sm': {
      marginTop: 32,
    },
  },
});

export const StyledStackCard = styled(Stack, {
  borderColor: '$Neutral03',
  borderRadius: 8,
  borderStyle: 'solid',
  borderWidth: 1,
  height: 148,
  minWidth: '100%',
  padding: 16,
  '@sm': {
    borderRadius: 0,
    borderLeft: 'none',
    borderRight: 'none',
    borderTop: 'none',
    [`'+ ${Stack}`]: {
      marginTop: 0,
    },
  },
  '@md': {
    minWidth: 280,
  },
  '@lg': {
    maxWidth: 380,
    minWidth: 380,
  },
});

export const StyledStackContainer = styled(Stack, {
  alignItems: 'center',
  display: 'flex',
  flexDirection: 'row !important',
  justifyContent: 'space-between',
});

export const StyledText = styled(Text, {
  '@sm': {
    marginLeft: 16,
  },
});
